import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMapExport = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 256 256",
	enableBackground: "new 0 0 256 256",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M94.2,80.6c-6.2,0-16.6,1.7-27.2,5.3l27.2,5.6V80.6z M240.3,79l-70.7-13.9c-0.5-0.1-1,0-1.4,0c-0.5,0-0.9-0.1-1.3,0l-29.6,5.8l-15,15.2l38.8-5.7v62.4l-58.4,10.6v-47.4l-8.4,8.5v38.9l-54.7-9.3c1.7,4.6,3.5,8.7,5.7,12.4l49,8.4v64.4L27,218.9v-65.6l1.4,0.2c-3.2-3-6-6.2-8.7-9.6v81.2c0,3.3,2.4,6.2,5.7,6.8l70.7,13.9c0.5,0.1,0.9,0.1,1.4,0.1c0.5,0,0.9,0,1.4-0.1l69.3-13.7l69.3,13.7c0.5,0.1,0.9,0.1,1.4,0.1c1.6,0,3.2-0.6,4.5-1.6c1.6-1.3,2.6-3.3,2.6-5.4V85.8C246,82.5,243.6,79.7,240.3,79z M161.1,219.4l-58.4,9.8v-64.4l58.4-7.8V219.4z M237.6,229.2l-67.4-11.5v-64.4l67.4,14.6V229.2z M237.6,153.4l-67.4-11.5V77.5l67.4,13.9V153.4z M58.8,170.2c-17.1-3.6-30-36.1-30-54.8c0-35.8,59-44.5,72.3-44.5v26.3l43.8-43.4L101.1,10v22.4C92,32.4,10,41.3,10,96C10,125.4,31.3,166.4,58.8,170.2z"
	}) }) })
});
export default SvgMapExport;
